/**
 * Weekday labels for KiTa / Kindergarten / Hort days stored on the child profile.
 * Attendance filtering is off: these days are memory, not a hide rule.
 */

/** ISO weekday Mon=1 … Sun=7 */
export const KITA_WEEKDAY_OPTIONS = [
  { value: 1, label: "Mo" },
  { value: 2, label: "Di" },
  { value: 3, label: "Mi" },
  { value: 4, label: "Do" },
  { value: 5, label: "Fr" },
];

/**
 * @param {unknown} children
 * @returns {number[]} sorted unique ISO weekdays
 */
export function getHouseholdKitaWeekdays(children) {
  const set = new Set();
  if (!Array.isArray(children)) return [];
  for (const child of children) {
    const days = child?.kita_weekdays;
    if (!Array.isArray(days)) continue;
    for (const raw of days) {
      const n = Number(raw);
      if (Number.isInteger(n) && n >= 1 && n <= 7) set.add(n);
    }
  }
  return [...set].sort((a, b) => a - b);
}

/**
 * @param {number[]} days
 */
export function formatKitaWeekdaysLabel(days) {
  const map = new Map(KITA_WEEKDAY_OPTIONS.map((o) => [o.value, o.label]));
  const labels = (days || []).map((d) => map.get(d) || String(d));
  if (labels.length === 0) return "";
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} und ${labels[1]}`;
  return `${labels.slice(0, -1).join(", ")} und ${labels[labels.length - 1]}`;
}
